import React from "react";
import { withRouter } from "react-router-dom";
import { Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import { Portal, Typography } from '@mui/material';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import {
  obtenerCatalogoMaguey,
  agregarNuevoMaguey,
  actualizarMaguey,
} from "../../../redux/DucksUsuarioAgricola/CatalogoMagueyDucks";
import { obtenerCatalogoMagueyNombreCientifico, agregarCatalogoMagueyNombreCientifico } from "../../../redux/DucksUsuarioAgricola/CatalogoNombreCientificoDucks";
import estilos from "./PanelInformacionPredio.module.css"

const styleForm = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 500,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

const styleModalConfirmacion = {
  position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)',
  width: 500, bgcolor: 'background.paper', border: '2px solid #000', boxShadow: 24,
  p: 4, fontSize: '20px', textAlign: 'center'
};

const PanelEditarMaguey = (props) => {
  const dispatch = useDispatch();
  const data = useSelector((store) => store.CatalogoMagueyApi?.data?.data);
  //const catalogonombrescientificos = useSelector((store) => store.CatalogoMagueyNombreCientifico.catalogo.data);

  const [modal, setModal] = React.useState(false)
  const [textoModal, setTextoModal] = React.useState('')
  const [tituloModal, setTituloModal] = React.useState('')

  const resetValores = (objectProducto) => {
    setModal(objectProducto.validacion)
  }

  const [nombrescientificos, setNombrescientificos] = React.useState([])
  const [modoEdicion, setModoEdicion] = React.useState(false);
  const [error, setError] = React.useState(null);
  const [actualizado, setActualizado] = React.useState(false);
  const [maguey, setMaguey] = React.useState({
    idcatalogomagueynombrecientifico: 0,
    nombrecomun: "",
    imagenruta: "",
    descripcion: "",
    activo: 0
  });

  const [openAgregarNombreCientifico, setOpenAgregarNombreCientifico] = React.useState(false);
  const [modalConfirmar, setModalConfirmar] = React.useState(false);
  const [nuevoNombreCientifico, setNuevoNombreCientifico] = React.useState();

  const [modalNombreCientificoRepetido, setModalNombreCientificoRepetido] = React.useState(false);
  const [modalNombreComunRepetido, setModalNombreComunRepetido] = React.useState(false);
  const [modalEspecieRepetido, setModalEspecieRepetido] = React.useState(false);

  const agregar = (e) => {
    e.preventDefault();
    if (!maguey.idcatalogomagueynombrecientifico.trim() || !maguey.nombrecomun.trim()) {
      setError("Ambos campos son Obligatorio");
      return;
    }


    const existe = data.some(objeto => objeto.idcatalogomagueynombrecientifico === Number(maguey.idcatalogomagueynombrecientifico) && objeto.nombrecomun === maguey.nombrecomun);
    if (existe) {
      handleOpenEspecieRepetido()
    } else {
      agregarMaguey();
    }

    setMaguey({
      idcatalogomagueynombrecientifico: "",
      nombrecomun: "",
      imagenruta: "",
      descripcion: "",
      activo: 0
    });
    setActualizado(false);
    setError(null);
  };

  const agregarMaguey = async () => {

    let arrayPalabras = maguey.nombrecomun.split(" ")
    let arrayPalabrasFormateadas = []

    arrayPalabras.forEach((p) => {
      let array = []
      array.push(p[0].toUpperCase())
      for (let index = 1; index < p.length; index++) {
        array.push(p[index].toLowerCase())
      }
      arrayPalabrasFormateadas.push(array)
    })

    let arrayPalabrasUnidas = []

    arrayPalabrasFormateadas.forEach((pf) => {
      arrayPalabrasUnidas.push(pf.join(''))
    })

    const nuevoMaguey = {
      idcatalogomagueynombrecientifico: Number(maguey.idcatalogomagueynombrecientifico),
      nombrecomun: arrayPalabrasUnidas.join(' '),
      imagenruta: "",
      descripcion: "",
      activo: 1
    }

    let nuevonombre = arrayPalabrasUnidas.join(' ');

    let nombreDuplicadoEncontrado = false;

    // data.forEach((n) => {
    //   if (n.nombrecomun !== nuevonombre && !nombreDuplicadoEncontrado) {
    //     nombreDuplicadoEncontrado = false;

    //   } else if (n.nombrecomun === nuevonombre) {
    //     nombreDuplicadoEncontrado = true;
    //   }
    // });

    // if (nombreDuplicadoEncontrado === false) {
    //   await dispatch(agregarNuevoMaguey({ data: nuevoMaguey }));
    //   setActualizado(true);
    // } else {
    //   handleOpenNombreComunRepetido();
    // }

    await dispatch(agregarNuevoMaguey({ data: nuevoMaguey }));
    setActualizado(true);

  };

  const actualizaMaguey = async (maguey) => {
    await dispatch(actualizarMaguey({ data: maguey }));
    setActualizado(true);
  };



  const editar = (item) => {
    setModoEdicion(true);
    setMaguey(item);
  };

  const editarMaguey = (e) => {
    e.preventDefault();
    if (!maguey.idcatalogomagueynombrecientifico.length === 0 || !maguey.nombrecomun.trim()) {
      setError("Ambos campos son Obligatorio");
      return;
    }

    let arrayPalabras = maguey.nombrecomun.split(" ")
    let arrayPalabrasFormateadas = []

    arrayPalabras.forEach((p) => {
      let array = []
      array.push(p[0].toUpperCase())
      for (let index = 1; index < p.length; index++) {
        array.push(p[index].toLowerCase())
      }
      arrayPalabrasFormateadas.push(array)
    })

    let arrayPalabrasUnidas = []

    arrayPalabrasFormateadas.forEach((pf) => {
      arrayPalabrasUnidas.push(pf.join(''))
    })

    const nuevoMaguey = {
      idcatalogomaguey: Number(maguey.idcatalogomaguey),
      idcatalogomagueynombrecientifico: Number(maguey.idcatalogomagueynombrecientifico),
      nombrecomun: arrayPalabrasUnidas.join(' '),
      imagenruta: "",
      descripcion: "",
      activo: Number(maguey.activo)
    }
    let nuevonombre = arrayPalabrasUnidas.join(' ');

    let nombreDuplicadoEncontrado = false;

    data.forEach((n) => {
      if (n.nombrecomun !== nuevonombre && !nombreDuplicadoEncontrado) {
        nombreDuplicadoEncontrado = false;

      } else if (n.nombrecomun === nuevonombre && n.idcatalogomaguey != maguey.idcatalogomaguey) {
        nombreDuplicadoEncontrado = true;
      }
    });

    if (nombreDuplicadoEncontrado === false) {
      actualizaMaguey(nuevoMaguey)

    } else {
      handleOpenNombreComunRepetido();
    }

    setModoEdicion(false);
    setMaguey({
      idcatalogomagueynombrecientifico: "",
      nombrecomun: "",
      imagenruta: "",
      descripcion: "",
      activo: 0
    });
    setError(null);
    setActualizado(false);
  };

  React.useEffect(() => {
    dispatch(obtenerCatalogoMaguey());
    dispatch(obtenerCatalogoMagueyNombreCientifico()).then((res) => {
      setNombrescientificos(res.payload.data.data)
    })
  }, []);


  React.useEffect(() => {
  }, [nombrescientificos])

  React.useEffect(() => {
    if (actualizado === true) {
      dispatch(obtenerCatalogoMaguey());
    }
  }, [actualizado]);

  const handleMagueyChange = (e) => {
    const { name, value } = e.target;
    setMaguey((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleOpenAgregarNombreCientifico = () => {
    setOpenAgregarNombreCientifico(true)
  }

  const handleCloseAgregarNombreCientifico = () => {
    setOpenAgregarNombreCientifico(false)
  }

  const handleOpenConfirmar = () => {
    setModalConfirmar(true);

  }

  const handleCloseConfirmar = () => {
    setModalConfirmar(false);
  }

  const handleOpenNombreCientificoRepetido = () => {
    setModalNombreCientificoRepetido(true);

  }

  const handleCloseNombreCientificoRepetido = () => {
    setModalNombreCientificoRepetido(false);
  }

  const handleOpenNombreComunRepetido = () => {
    setModalNombreComunRepetido(true);

  }

  const handleCloseNombreComunRepetido = () => {
    setModalNombreComunRepetido(false);
  }

  const handleOpenEspecieRepetido = () => {
    setModalEspecieRepetido(true);

  }

  const handleCloseEspecieRepetido = () => {
    setModalEspecieRepetido(false);
  }

  const agregarNuevoNombreCientifico = () => {
    dispatch(agregarCatalogoMagueyNombreCientifico(nuevoNombreCientifico)).then((res) => {
      dispatch(obtenerCatalogoMagueyNombreCientifico()).then((r) => {
        setNombrescientificos(r.payload.data.data)
      })
      handleCloseConfirmar()
      handleCloseAgregarNombreCientifico()
    })
  }

  const salirModoEdicion = () => {
    setModoEdicion(false);
    setMaguey({
      idcatalogomagueynombrecientifico: "",
      nombrecomun: "",
      imagenruta: "",
      descripcion: "",
      activo: 0
    });
  }

  const HTMLmodalConfirmarAgregarNombreCientifico = () => {
    return (
      <Modal
        open={modalConfirmar}
        onClose={handleCloseConfirmar}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description">
        <Box sx={styleModalConfirmacion} >
          <h3>Agregar Nombre Cientifico</h3>
          Estás seguro de querer agregar este Nombre Cientifico?<br></br>
          <br />
          <button onClick={agregarNuevoNombreCientifico} className='btn btn-danger'>Si, estoy seguro</button>
        </Box>

      </Modal>
    )
  }

  const HTMLmodalEspecieDuplicado = () => {
    return (
      <Modal
        open={modalEspecieRepetido}
        onClose={handleCloseEspecieRepetido}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description">
        <Box sx={styleModalConfirmacion} >
          <h3>Esta Especie de Maguey ya existe</h3>
          Ingrese una nueva especie<br></br>
          <br />
          <button onClick={handleCloseEspecieRepetido} className='btn btn-danger'>ACEPTAR</button>
        </Box>

      </Modal>
    )
  }

  const HTMLmodalNombreCientificoDuplicado = () => {
    return (
      <Modal
        open={modalNombreCientificoRepetido}
        onClose={handleCloseNombreCientificoRepetido}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description">
        <Box sx={styleModalConfirmacion} >
          <h3>Este Nombre Cientifico ya existe</h3>
          Ingrese un Nuevo Nombre Cientifico<br></br>
          <br />
          <button onClick={handleCloseNombreCientificoRepetido} className='btn btn-danger'>ACEPTAR</button>
        </Box>

      </Modal>
    )
  }

  const HTMLmodalNombreComunDuplicado = () => {
    return (
      <Modal
        open={modalNombreComunRepetido}
        onClose={handleCloseNombreComunRepetido}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description">
        <Box sx={styleModalConfirmacion} >
          <h3>Este Nombre Comun ya existe</h3>
          Ingrese un Nuevo Nombre Comun<br></br>
          <br />
          <button onClick={handleCloseNombreComunRepetido} className='btn btn-danger'>ACEPTAR</button>
        </Box>

      </Modal>
    )
  }

  const modalAgregarNuevoNombreCientifico = () => {
    return (
      <div>
        <Modal
          open={openAgregarNombreCientifico}
          onClose={handleCloseAgregarNombreCientifico}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={styleForm}>
            <Typography id="modal-modal-title" variant="h6" component="h2">
              <div style={{ textAlign: "center" }}>
                Nuevo Nombre Cientifico
              </div>
            </Typography>
            <Typography id="modal-modal-description" component="h2" sx={{ mt: 2 }}>
              <div className="container">
                <Formik
                  initialValues={{
                    nombrecientifico: ''
                  }}
                  enableReinitialize={true}
                  validate={(values) => {
                    const errors = {}
                    let arrayPalabras = values.nombrecientifico.split(" ")
                    let arrayPalabrasFormateadas = []

                    arrayPalabras.forEach((p) => {
                      let array = []
                      array.push(p[0].toUpperCase())
                      for (let index = 1; index < p.length; index++) {
                        array.push(p[index].toLowerCase())
                      }
                      arrayPalabrasFormateadas.push(array)
                    })
                    let arrayPalabrasUnidas = []

                    arrayPalabrasFormateadas.forEach((pf) => {
                      //arrayPalabrasUnidas += pf
                      arrayPalabrasUnidas.push(pf.join(''))
                    })

                    let filtro = nombrescientificos.filter(anexo => anexo.nombrecientifico == arrayPalabrasUnidas?.[0])
                    if (filtro.length > 0) {
                      errors.nombrecientifico = 'El nombre cientifico ya existe';
                    }
                    if (values.nombrecientifico == '') {
                      errors.nombrecientifico = 'Ingrese el Nuevo Nombre Cientifico';
                    }

                    return errors;
                  }}
                  onSubmit={(values) => {
                    let arrayPalabras = values.nombrecientifico.split(" ")
                    let arrayPalabrasFormateadas = []

                    arrayPalabras.forEach((p) => {
                      let array = []
                      array.push(p[0].toUpperCase())
                      for (let index = 1; index < p.length; index++) {
                        array.push(p[index].toLowerCase())
                      }
                      arrayPalabrasFormateadas.push(array)
                    })

                    let arrayPalabrasUnidas = []
                    arrayPalabrasFormateadas.forEach((pf) => {
                      arrayPalabrasUnidas.push(pf.join(''))
                    })

                    const data = {
                      data: {
                        nombrecientifico: arrayPalabrasUnidas.join(' ')
                      }
                    }

                    let nuevonombre = arrayPalabrasUnidas.join(' ');

                    let nombreDuplicadoEncontrado = false;

                    nombrescientificos.forEach((n) => {
                      if (n.nombrecientifico !== nuevonombre && !nombreDuplicadoEncontrado) {
                        nombreDuplicadoEncontrado = false;

                      } else if (n.nombrecientifico === nuevonombre) {
                        nombreDuplicadoEncontrado = true;
                      }
                    });

                    if (nombreDuplicadoEncontrado === false) {
                      setNuevoNombreCientifico(data);
                      handleOpenConfirmar();
                    } else {
                      handleOpenNombreCientificoRepetido();
                    }

                    //setNuevoNombreCientifico(data)
                    //handleOpenConfirmar()
                  }}
                >
                  {(props) => (
                    <Form>
                      <div className='form-row'>
                        <div className="form-group col">
                          <label for="nombrecientifico" class="row-sm-2 row-form-label">Nombre Cientifico: </label>
                          <div class="col">
                            <Field type="text" class="form-control" id="nombrecientifico" name="nombrecientifico" />
                            <ErrorMessage name="nombrecientifico" component="div" style={{ color: 'red', fontSize: '10pt' }} />
                          </div>
                        </div>
                      </div>
                      <br></br>
                      <div className='text-center'>
                        <div className="row">
                          <div className="col">
                            <button className='btn btn-success' type='submit'>GUARDAR</button>
                          </div>
                          <div className="col">
                            <button className='btn btn-danger' type='button' onClick={handleCloseAgregarNombreCientifico}>CANCELAR</button>
                          </div>
                        </div>
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
            </Typography>
            <br />

          </Box>
        </Modal>
      </div>
    )
  }

  return (
    <Fragment>
      <div className="container">
        <div className="bg-light p-5 rounded ms-5">
          <h3 className="text-center">Catálogo de Maguey</h3>
          <hr />
          <div className="row">
            <div className="col-8">
              <h4 className={`${estilos.labelEspecial} text-center mb-3`}>Lista de Maguey</h4>
              <ul className="list-group">
                {data?.length === 0 ? (
                  <li className="list-group-item">No hay nuevas especies</li>
                ) : (
                  data?.map((item) => {
                    return (
                      <li className="list-group-item" key={item.idcatalogomaguey}>
                        <span className="lead"> <i style={{ "fontStyle": "italic" }}> {item?.catalogomagueynombrecientifico?.nombrecientifico} </i>  -  {item?.nombrecomun}
                          <span className={item.activo === 1 ? "badge rounded-pill  bg-success float-start mx-2" : "badge rounded-pill  bg-danger float-start mx-2"}>
                            {item.activo === 1 ? "Activo" : "Desactivado"}
                          </span>
                        </span>

                        <button
                          className="btn btn-sm btn-warning float-end"
                          onClick={() => editar(item)}
                        >
                          Editar
                        </button>
                      </li>
                    )
                  })
                )}
              </ul>
            </div>
            <div className="col-4">
              <h4 className={`${estilos.labelEspecial} text-center mb-3`}>
                {modoEdicion ? "Editar Maguey" : "Agregar Especie"}
              </h4>
              <form onSubmit={modoEdicion ? editarMaguey : agregar}>
                {error ? <span className="text-danger">{error}</span> : null}
                <input
                  type="text"
                  className="form-control mb-2"
                  placeholder="Ingrese Nombre común"
                  onChange={handleMagueyChange}
                  name="nombrecomun"
                  value={maguey.nombrecomun}
                />
                {/* <input
                  type="text"
                  className="form-control mb-2"
                  placeholder="Nombre científico"
                  onChange={handleMagueyChange}
                  value={maguey.nombrecientifico}
                  name="nombrecientifico"
                /> */}
                <select
                  className="form-select mb-2"
                  aria-label="Nombre Cientifico"
                  onChange={handleMagueyChange}
                  name="idcatalogomagueynombrecientifico"
                  value={maguey.idcatalogomagueynombrecientifico}
                >
                  <option defaultValue>Seleccione Nombre Cientifico</option>
                  {
                    nombrescientificos && nombrescientificos.length > 0 ?
                      nombrescientificos.map((n, index) => {
                        return (
                          <option key={index} value={Number(n.idcatalogomagueynombrecientifico)}>{n.nombrecientifico}</option>
                        )
                      })
                      :
                      <p>asd</p>
                  }
                </select>
                {modoEdicion ? (

                  <>
                    <select
                      className="form-select mb-2"
                      aria-label="Estado"
                      onChange={handleMagueyChange}
                      name="activo"
                      value={maguey.activo}
                    >

                      <option value="1">Activo</option>
                      <option value="2">Desactivado</option>
                    </select>


                    <div className="row">
                      <div className="col">
                        <button className="btn btn-success btn-block" type="submit">
                          Aceptar
                        </button>
                      </div>
                      <div className="col">
                        <button className='btn btn-danger ' type='button' onClick={() => salirModoEdicion()}>Cancelar</button>
                      </div>
                    </div>
                  </>

                ) : (
                  <div className="row">
                    <div className="col">
                      <button className="btn btn-success btn-block" type="submit">
                        Agregar
                      </button>
                    </div>
                    <div className="col">
                      <button className="btn btn-warning btn-sm" type="button" onClick={handleOpenAgregarNombreCientifico}>
                        Agregar Nombre Cientifico
                      </button>
                    </div>
                  </div>
                )}
              </form>
            </div>
          </div>
        </div>
      </div>
      {modalAgregarNuevoNombreCientifico()}
      {HTMLmodalConfirmarAgregarNombreCientifico()}
      {HTMLmodalNombreCientificoDuplicado()}
      {HTMLmodalNombreComunDuplicado()}
      {HTMLmodalEspecieDuplicado()}
      {modal && <ModalMensaje texto={textoModal} titulo={tituloModal} api={{ resetValores }}></ModalMensaje>}
    </Fragment>
  );
};

export default withRouter(PanelEditarMaguey);
